export default function WalletIcon({
    style,
}){
    return <svg style={style} width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.8846 7.53576V7.07422C20.8846 5.41736 19.5415 4.07422 17.8846 4.07422H4.5C2.84314 4.07422 1.5 5.41736 1.5 7.07422V7.53576H16.7308H20.3077C21.9645 7.53576 23.3077 8.8789 23.3077 10.5358V21.4973C23.3077 23.1542 21.9645 24.4973 20.3077 24.4973H4.5C2.84315 24.4973 1.5 23.1542 1.5 21.4973V7.1896" stroke="#536987" strokeWidth="1.5"/>
    <path d="M14.7307 0.804763L17.1538 6.99707H3.99994L14.7307 0.804763Z" fill="#83CFA4"/>
    <path d="M16.0381 15.8434C16.0381 14.314 17.2779 13.0742 18.8073 13.0742H23.6535V18.6127H18.8073C17.2779 18.6127 16.0381 17.3729 16.0381 15.8434Z" fill="#83CFA4"/>
    <circle cx="18.8075" cy="15.8416" r="1.38462" fill="white" stroke="#536987"/>
    </svg>
}
